var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-color/~/lodash/_getPrototype.js
 ** module id = 1485
 ** module chunks = 0
 **/